
/**
 * SEO 配置 - models (Türkçe)
 */

export default {
    veo_3_1: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Senkronize ses ve çoklu çekim anlatı tutarlılığı ile OpenAI Sora 2 kullanarak fiziksel olarak doğru, gerçekçi AI videoları oluşturun.',
        keywords: 'Sora 2, OpenAI Sora, video modeli, gerçekçi AI video, metinden videoya, WeryAI',
    },
    weryai_video_1: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Yerel AI Görsel Oluşturucu | WeryAI',
        description: 'WeryAI Image 2 ile muhteşem yerel AI görsel üretimi! Amiral gemisi model gelişmiş stil kontrolü. Ücretsiz krediler, kart gerekmez.',
        keywords: 'WeryAI Image 2, yerel AI görsel oluşturucu, amiral gemisi AI görsel, stüdyo kalitesi AI, WeryAI Image ücretsiz, WeryAI Image 2 nasıl kullanılır, WeryAI',
    },
    image_grok_2: {
        title: 'Ücretsiz Grok 2 - xAI Görsel Oluşturucu | WeryAI',
        description: 'WeryAI\'de Grok 2 ile yaratıcı AI görselleri oluşturun! xAI modeli sanatsal esneklik ve benzersiz stiller. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Grok 2, Grok AI, xAI görsel oluşturucu, AI sanat, yaratıcı AI görselleri, Grok 2 ücretsiz, Grok 2 nasıl kullanılır, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Görüntü Oluşturucu | WeryAI',
        description: 'Nano Banana 2, dünya bilgisi ve gerçek zamanlı arama ile Gemini tarafından desteklenmektedir. Ultra hızlı bir şekilde doğru ve etkileyici görüntüler oluşturun.',
        keywords: 'Nano Banana 2, Google AI, Gemini, görüntü oluşturma, metin işleme, çok özneli tutarlılık, 4K, WeryAI',
        og_title: 'Nano Banana 2 Görüntü Oluşturucu | WeryAI',
        og_description: 'Nano Banana 2, dünya bilgisi ve gerçek zamanlı arama ile Gemini tarafından desteklenmektedir. Ultra hızlı bir şekilde doğru ve etkileyici görüntüler oluşturun.',
        twitter_title: 'Nano Banana 2 Görüntü Oluşturucu | WeryAI',
        twitter_description: 'Nano Banana 2, dünya bilgisi ve gerçek zamanlı arama ile Gemini tarafından desteklenmektedir. Ultra hızlı bir şekilde doğru ve etkileyici görüntüler oluşturun.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Nano Banana 2 AI görsel oluşturucu',
        twitterImageAlt: 'Nano Banana 2 AI görsel oluşturucu',
    },
    kling_ai: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Kling 2.5 Turbo, gelişmiş lens kontrolü, duygusal ifadeler ve akıcı hareket fiziği ile sinematik, yüksek kaliteli AI videoları oluşturur.',
        keywords: 'Kling 2.5 Turbo, Kling AI, sinematik AI video, lens kontrolü AI, WeryAI',
    },
    runway_ai: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: `Runway Gen-4, daha derin istem anlayışı ve akıllı düzenleme araçlarıyla gerçekçi, tutarlı yapay zeka videoları üretir. WeryAI'de ücretsiz deneyin.`,
        keywords: 'Runway Gen-4, Runway AI, yapay zeka video oluşturucu, metinden videoya, görüntüden videoya, yapay zeka video düzenleme, WeryAI',
    },
    hailuo_23: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: `WeryAI\'da Hailuo AI ile gelişmiş AI videoları oluşturun. En yeni hareket kontrolü ve gerçekçi sahne oluşturma özellikleri.`,
        keywords: 'Hailuo AI, MiniMax, AI video oluşturucu, hareket kontrolü, gerçekçi video, WeryAI',
    },
    pika_2_2: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'Seedance Yapay Zeka Video Üreticisi - Dans ve Hareket Oluşturma on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        description: 'Werydance 2.0 ile yönetmen seviyesi AI videolar oluşturun: çok modlu referanslar, anlatı tutarlılığı ve fizik simülasyonu. WeryAI\'da ücretsiz.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, AI video oluşturucu, yönetmen seviyesi video, çoklu modal video, fizik simülasyonu, dudak senkronizasyonu, metinden videoya, ücretsiz AI video, WeryAI',

        og_title: 'Werydance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        og_description: 'Werydance 2.0 ile yönetmen seviyesi AI videolar oluşturun: çok modlu referanslar, anlatı tutarlılığı ve fizik simülasyonu. WeryAI\'da ücretsiz.',

        twitter_title: 'Werydance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        twitter_description: 'Werydance 2.0 ile yönetmen seviyesi AI videolar oluşturun: çok modlu referanslar, anlatı tutarlılığı ve fizik simülasyonu. WeryAI\'da ücretsiz.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Ücretsiz Nano Banana Pro - AI Görsel Oluşturucu | WeryAI',
        description: 'WeryAI\'de Nano Banana Pro ile en yüksek kalitede AI görselleri! Midjourney kalitesinde rakip. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google AI görsel, akıl yürütme AI görsel, 4K AI görsel, Nano Banana Pro ücretsiz, Nano Banana Pro nasıl kullanılır, WeryAI',
    },
    image_nano_banana: {
        title: 'Ücretsiz Nano Banana - AI Görsel Oluşturucu | WeryAI',
        description: 'WeryAI\'de Nano Banana ile kolayca AI görselleri oluşturun! Çok yönlü ve hızlı AI görsel modeli. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google AI görsel, hızlı AI oluşturucu, karakter tutarlılığı, Nano Banana ücretsiz, Nano Banana nasıl kullanılır, WeryAI',
    },
    image_flux: {
        title: 'Ücretsiz FLUX - AI Görsel Oluşturucuyu Deneyin | WeryAI',
        description: 'WeryAI\'de FLUX kullanarak muhteşem AI görselleri oluşturun! Stable Diffusion ekibi tarafından olağanüstü görsel kalitesiyle. Ücretsiz krediler, kart gerekmez.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, AI görsel oluşturucu, metin görsel, AI sanat, FLUX ücretsiz, FLUX nasıl kullanılır, WeryAI',
    },
    image_flux_kontext: {
        title: 'Ücretsiz FLUX Kontext - Pro AI Görsel Editörü | WeryAI',
        description: 'WeryAI\'de FLUX Kontext ile profesyonel AI görsel düzenleme! Üstün doğruluk, gelişmiş tipografi ve çok aşamalı düzenleme. Ücretsiz krediler, kart gerekmez.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, AI görsel editörü, profesyonel AI görselleri, tipografi AI, FLUX Kontext ücretsiz, FLUX Kontext nasıl kullanılır, WeryAI',
    },
    image_imagen: {
        title: 'Ücretsiz Imagen 4 - Google AI Görsel Oluşturucu | WeryAI',
        description: 'WeryAI\'de Google Imagen 4 ile fotorealistik AI görselleri oluşturun! Çok yönlü stil kontrolü ve hassas metin üretimi. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Imagen 4, Google Imagen, Google AI görsel oluşturucu, metin görsel, fotorealistik AI, Imagen ücretsiz, Imagen 4 nasıl kullanılır, WeryAI',
    },
    image_qwen_image: {
        title: 'Ücretsiz Qwen Image - Alibaba AI Görsel Modeli | WeryAI',
        description: 'WeryAI\'de Qwen Image ile çok dilli AI sanatı oluşturun! Alibaba açık kaynak modeli üstün metin işleme. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Qwen Image, Alibaba AI, açık kaynak AI görsel, çok dilli metin işleme, Qwen Image ücretsiz, Qwen Image nasıl kullanılır, WeryAI',
    },
    image_wan_ai: {
        title: 'Ücretsiz Wan AI - Alibaba Görsel Oluşturucu | WeryAI',
        description: 'WeryAI\'de Wan AI ile yüksek doğrulukta AI görselleri! Alibaba modeli hassas komut takibi ve fotorealistik işleme. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Wan AI, Wan 2.5, Alibaba AI görsel oluşturucu, metin görsel, fotorealistik AI, Wan AI ücretsiz, Wan AI nasıl kullanılır, WeryAI',
    },
    image_seendream: {
        title: 'Ücretsiz Seedream 4.0 - ByteDance Görsel AI | WeryAI',
        description: 'WeryAI\'de Seedream 4.0 ile ultra hızlı AI görsel üretimi! ByteDance modeli çeşitli sanat stilleri. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Seedream, Seedream 4.0, ByteDance görsel AI, ultra hızlı AI görsel, sanatsal AI stilleri, Seedream ücretsiz, Seedream nasıl kullanılır, WeryAI',
    },
    image_dreamina: {
        title: 'Ücretsiz Dreamina 4.0 - Çok Modlu Görsel AI | WeryAI',
        description: 'WeryAI\'de Dreamina 4.0 ile çok modlu AI görsel oluşturma! Eskiz görsel, stil aktarımı ve karakter birleşimi. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Dreamina 4.0, ByteDance görsel AI, çok modlu AI görsel, eskiz görsel, stil aktarımı, Dreamina ücretsiz, Dreamina 4.0 nasıl kullanılır, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Ücretsiz Seedream 4.5 - ByteDance Görsel AI | WeryAI',
        description: 'WeryAI\'de Seedream 4.5 ile amiral gemisi AI görsel üretimi! ByteDance en yenisi hassas tipografi ile. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Seedream 4.5, ByteDance görsel AI, amiral gemisi model, tipografi işleme, çoklu görsel birleşimi, Seedream 4.5 ücretsiz, Seedream 4.5 nasıl kullanılır, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 ByteDance Nihai AI Görüntü Oluşturma | WeryAI',
        description: 'Seedream 5.0, ByteDance\'ın AI görsel alanındaki başyapıtıdır; yerel 8K kalite, nihai anlamsal anlayış, çoklu konu kompozisyonu ve metin işleme 2.0 sunar. WeryAI\'de ücretsiz deneyin.',
        keywords: 'Seedream 5.0, yapay zeka görüntü oluşturma, 8K kalite, anlamsal anlayış, çoklu konu kompozisyonu, metin işleme, ByteDance, WeryAI',
        og_title: 'Seedream 5.0 ByteDance Nihai AI Görüntü Oluşturma | WeryAI',
        og_description: 'Seedream 5.0, ByteDance\'ın AI görsel alanındaki başyapıtıdır; yerel 8K kalite, nihai anlamsal anlayış, çoklu konu kompozisyonu ve metin işleme 2.0 sunar. WeryAI\'de ücretsiz deneyin.',
        twitter_title: 'Seedream 5.0 ByteDance Nihai AI Görüntü Oluşturma | WeryAI',
        twitter_description: 'Seedream 5.0, ByteDance\'ın AI görsel alanındaki başyapıtıdır; yerel 8K kalite, nihai anlamsal anlayış, çoklu konu kompozisyonu ve metin işleme 2.0 sunar. WeryAI\'de ücretsiz deneyin.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Seedream 5.0 AI görsel oluşturucu',
        twitterImageAlt: 'Seedream 5.0 AI görsel oluşturucu',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Profesyonel AI Vektör Grafik Üreteci | WeryAI',
        description: 'Recraft V4 Vector, Recraft.ai tarafından sunulan profesyonel bir AI vektör grafik üreticisidir; düzenlenebilir SVG vektörleri kayıpsız ölçeklendirme, hassas tipografi ve marka stili kontrolü ile oluşturur. WeryAI\'de şimdi ücretsiz deneyin.',
        keywords: 'Recraft V4 Vector, AI vektör oluşturma, SVG üreteci, gerçek vektör, logo tasarımı, UI simgeleri, vektör illüstrasyon, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Ücretsiz Midjourney - AI Sanat Oluşturucuyu Deneyin | WeryAI',
        description: 'WeryAI\'de Midjourney ile sanatsal AI görselleri oluşturun! Çarpıcı estetik ve aydınlatma kalitesiyle ünlü. Ücretsiz krediler, kart gerekmez.',
        keywords: 'Midjourney, Midjourney AI, AI sanat oluşturucu, sanatsal AI görselleri, Midjourney ücretsiz, Midjourney alternatifi, Midjourney nasıl kullanılır, WeryAI',
    },
    runway_4_5: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'WeryAI\'de Runway Gen-4.5 ile muhteşem videolar oluşturun. Hassas fizik simülasyonu ve zamansal tutarlılık için hibrit otoregresif-difüzyon mimarisi.',
        keywords: 'Runway Gen-4.5, yapay zeka video oluşturucu, sinematik yapay zeka videosu, fizik simülasyonu, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'WeryAI\'de Kling 2.6 Pro ile yüksek kaliteli videolar üretin. Yerel görsel-işitsel üretim, sinematik 1080p kalite, mükemmel prompt uyumu.',
        keywords: 'Kling 2.6 Pro, yapay zeka video oluşturucu, yüksek kalite yapay zeka videosu, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'WeryAI\'de Dreamina 3.0 (Jimeng 3.0) ile sinematik yapay zeka videoları üretin. Hassas başlangıç/bitiş kare kontrolü, profesyonel kamera hareketleri ve 1080p yüksek dinamik video üretimi.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, yapay zeka video oluşturucu, kamera kontrolü, başlangıç bitiş karesi, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',
        description: 'WeryAI\'de Kling O1 yapay zeka video oluşturucu ile yaratıcılığınızı serbest bırakın. Hayal gücü dolu ve benzersiz video içeriği üretmek için mükemmel.',
        keywords: 'Kling O1, yapay zeka video oluşturucu, yaratıcı yapay zeka videosu, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        description: 'Kling 3.0 ile AI videolar oluşturun: akıllı storyboard, çok dilli dudak senkronizasyonu ve hassas metin işleme. WeryAI\'da ücretsiz deneyin.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, AI video oluşturucu, akıllı storyboard, dudak senkronizasyonu, metin işleme, metinden videoya, görselden videoya, ücretsiz AI video, WeryAI',

        og_title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        og_description: 'Kling 3.0 ile AI videolar oluşturun: akıllı storyboard, çok dilli dudak senkronizasyonu ve hassas metin işleme. WeryAI\'da ücretsiz deneyin.',

        twitter_title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        twitter_description: 'Kling 3.0 ile AI videolar oluşturun: akıllı storyboard, çok dilli dudak senkronizasyonu ve hassas metin işleme. WeryAI\'da ücretsiz deneyin.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        description: 'Vidu Q3 ile yerel 16 saniyelik ses-video üretin: akıllı kesim, hassas metin işleme ve çok dilli dudak senkronizasyonu. WeryAI\'da ücretsiz.',

        keywords: 'Vidu Q3, Vidu AI, AI video oluşturucu, yerel 16s ses-video, akıllı storyboard, metin işleme, dudak senkronizasyonu, metinden videoya, görselden videoya, ücretsiz AI video, WeryAI',

        og_title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        og_description: 'Vidu Q3 ile yerel 16 saniyelik ses-video üretin: akıllı kesim, hassas metin işleme ve çok dilli dudak senkronizasyonu. WeryAI\'da ücretsiz.',

        twitter_title: 'Seedance 2.0 - Yönetmen Seviye AI Video | WeryAI',

        twitter_description: 'Vidu Q3 ile yerel 16 saniyelik ses-video üretin: akıllı kesim, hassas metin işleme ve çok dilli dudak senkronizasyonu. WeryAI\'da ücretsiz.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Ücretsiz GPT-4o - OpenAI Görsel Oluşturucu | WeryAI',
        description: 'WeryAI\'de GPT-4o ile sohbet yoluyla görsel oluşturun! OpenAI hassas metin işleme ve yüksek kaliteli sonuçlar. Ücretsiz krediler, kart gerekmez.',
        keywords: 'GPT-4o, GPT-4o görsel, OpenAI görsel oluşturucu, sohbet AI sanat, GPT-4o ücretsiz, GPT-4o görselleri nasıl kullanılır, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Ücretsiz GPT Image 1.5 - OpenAI Sanat Oluşturucu | WeryAI',
        description: 'WeryAI\'de GPT Image 1.5 ile yeni nesil AI sanatı! OpenAI\'nin en yeni modeli gelişmiş yaratıcılık ile. Ücretsiz krediler, kart gerekmez.',
        keywords: 'GPT Image 1.5, OpenAI görsel modeli, AI sanat oluşturucu, yeni nesil AI, GPT Image 1.5 ücretsiz, GPT Image 1.5 nasıl kullanılır, WeryAI',
    },
}
